import { UserManager, UserManagerSettings } from "oidc-client";
import { createUserManager } from "redux-oidc";
import { ClientStsConfiguration, getClientConfiguration } from "../../configuration";

let userManager: UserManager;

export const getUserManager = () => {
  if (!userManager) {
    const stsClientConfiguration = getClientConfiguration().sts;
    const userManagerConfig = getUserManagerConfig(stsClientConfiguration);
    userManager = createUserManager(userManagerConfig);
  }
  return userManager;
};

const getUserManagerConfig = (stsClientConfiguration: ClientStsConfiguration): UserManagerSettings => ({
  client_id: stsClientConfiguration.apiClientName,
  response_type: "id_token token",
  scope: `openid profile email ${stsClientConfiguration.apiName}`,
  authority: stsClientConfiguration.authority,
  redirect_uri: `${window.location.origin}/auth/signin-oidc`,
  post_logout_redirect_uri: `${window.location.origin}/auth/signout-oidc`,
  silent_redirect_uri: `${window.location.origin}/auth/silent-renew.html`,
  automaticSilentRenew: true,
  filterProtocolClaims: true,
  loadUserInfo: true,
});
